export default __webpack_public_path__ + "static/media/element_99.7b88460c.jpg";